import React, { useState } from 'react';
import DataTableWithForm from '../components/DataTableWithForm';
import CompartmentEditor from '../components/CompartmentEditor';
import { API_BASE } from '../config';

const MachineLocation = () => {
  const fetchUrl = '/zts/admin/v1.0/machine/location/';
  const createUrl = '/zts/admin/v1.0/machine/location/';
  const updateUrl = id => `/zts/admin/v1.0/machine/location/${id}/`;
  const deleteUrl = id => `/zts/admin/v1.0/machine/location/${id}/`;

  const columns = [
    { field: 'serial', label: 'Serial' },
    { field: 'config_display', label: 'Config' },
    { field: 'location', label: 'Location' },
    { field: 'date_start', label: 'Date Start' },
    { field: 'owner_display', label: 'Owner' },
    { field: 'is_active', label: 'Active' }
  ];

  const formFields = [
    { name: 'serial', label: 'Serial' },
    { name: 'config', label: 'Config ID' },
    { name: 'location', label: 'Location' },
    { name: 'date_start', label: 'Date Start', type: 'datetime-local' },
    { name: 'owner', label: 'Owner ID' },
    { name: 'is_active', label: 'Active' },
    {
      name: 'layout',
      label: 'Compartment Layout',
      render: (value, onChange) => {
        let parsed = {};
        if (typeof value === 'string') {
          try {
            parsed = JSON.parse(value);
          } catch (e) {
            parsed = {};
          }
        } else if (typeof value === 'object' && value !== null) {
          parsed = value;
        }

        const layoutArray = Array.isArray(parsed?.layout) ? parsed.layout : [];
        const maxCol = typeof parsed?.max_col === 'number' ? parsed.max_col : 6;

        return (
          <CompartmentEditor
            initialLayout={layoutArray}
            initialMaxCol={maxCol}
            onLayoutChange={(layoutData) => onChange({
              layout: layoutData.layout,
              max_col: layoutData.max_col,
            })}
          />
        );
      }
}
  ];

  return (
    <DataTableWithForm
      title="Machine Location"
      fetchUrl={fetchUrl}
      createUrl={createUrl}
      updateUrl={updateUrl}
      deleteUrl={deleteUrl}
      columns={columns}
      formFields={formFields}
    />
  );
};

export default MachineLocation;





// import React from 'react';
// import DataTableWithForm from '../components/DataTableWithForm';
// import { API_BASE } from '../config';

// const MachineLocation = () => {
//   const fetchUrl = '/zts/admin/v1.0/machine/location/';
//   const createUrl = '/zts/admin/v1.0/machine/location/';
//   const updateUrl = id => `/zts/admin/v1.0/machine/location/${id}/`;
//   const deleteUrl = id => `/zts/admin/v1.0/machine/location/${id}/`;

//   const columns = [
//     { field: 'serial', label: 'Serial' },
//     { field: 'config_display', label: 'Config' },
//     { field: 'location', label: 'Location' },
//     { field: 'date_start', label: 'Date Start' },
//     { field: 'owner_display', label: 'Owner' },
//     { field: 'is_active', label: 'Active' }
//   ];

//   const formFields = [
//     { name: 'serial', label: 'Serial' },
//     { name: 'config', label: 'Config ID' },
//     { name: 'location', label: 'Location' },
//     { name: 'date_start', label: 'Date Start', type: 'datetime-local' },
//     { name: 'owner', label: 'Owner ID' },
//     { name: 'is_active', label: 'Active' }
//   ];

//   return (
//     <DataTableWithForm
//       title="Machine Location"
//       fetchUrl={fetchUrl}
//       createUrl={createUrl}
//       updateUrl={updateUrl}
//       deleteUrl={deleteUrl}
//       columns={columns}
//       formFields={formFields}
//     />
//   );
// };

// export default MachineLocation;
